// extracted by mini-css-extract-plugin
export default {"open-img":"OpenImg_open-img__JQjQH","open-spn":"OpenImg_open-spn__D-TU2"};